import { render, staticRenderFns } from "./TipiLavorazione.vue?vue&type=template&id=f7a5fb72"
import script from "./TipiLavorazione.vue?vue&type=script&lang=js"
export * from "./TipiLavorazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports